
const digest = '4a968b6759e1fa430afe31b3199756b86e2004c1abc94b2ce963fb256745a4e6';
const classes = {"wrapper":"_wrapper_1qs8k_1","title":"_title_1qs8k_14"};
const css = `._wrapper_1qs8k_1 {
  border-radius: 5px;
  padding: 26px 24px;
  font-family: Rubik, sans-serif;
  cursor: pointer;
  border: dashed 1px #979797;
  text-align: center;
  background: rgba(216, 216, 216, 0.2);
}
._wrapper_1qs8k_1:hover {
  transform: scale(1.025);
}

._title_1qs8k_14 {
  font-size: 14px;
  font-weight: 500;
  color: #3e3f42;
  text-decoration: underline;
  margin-top: 8px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  